import { render } from "./RecuConsultation.vue?vue&type=template&id=35d16a41&scoped=true"
import script from "./RecuConsultation.vue?vue&type=script&lang=js"
export * from "./RecuConsultation.vue?vue&type=script&lang=js"

import "./RecuConsultation.vue?vue&type=style&index=0&id=35d16a41&scoped=true&lang=css"
import "./RecuConsultation.vue?vue&type=style&index=1&id=35d16a41&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d16a41"]])

export default __exports__